import { ShaderMaterial, Vector2 } from 'three';

import { fragmentShader } from './shaders/fragmentShader';
import { vertexShader } from './shaders/vertexShader';

export default class extends ShaderMaterial {
    constructor() {
        super({
            vertexShader,
            fragmentShader,
            transparent: true,
            uniforms: {
                envMap: { value: null },
                showNormal: { value: 1 },
                opacity: { value: 0 },
                backfaceNormalTexture: { value: null },
                liquidNormalTexture: { value: null },
                innerContentTexture: { value: null },
                innerContentTextureMask: { value: null },
                noiseTexture: { value: null },
                rippleAmount: { value: 0 },
                resolution: { value: new Vector2() },
                time: { value: 0 },
                twist: { value: 0 },
            },
        });
    }
}
